import React, { useState } from "react";
import { Header, Home, About , Footer , Blog, Contact} from "../";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function Main({toggleTheme}) {

  return (
    <div className="bg-white-800 dark:bg-slate-900">
      <Router>
        <Header toggleTheme={toggleTheme} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default Main;
